import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var ErrorIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 16 15" }),
        React.createElement("path", { d: "M0.781367 14.0263H15.2186C15.8186 14.0263 16.1925 13.3796 15.8965 12.8576L8.67395 0.391513C8.37009 -0.130504 7.62212 -0.130504 7.32605 0.391513L0.103524 12.8576C-0.192545 13.3796 0.181437 14.0263 0.781367 14.0263ZM8.78303 11.6889H7.22477V10.1306H8.78303V11.6889ZM8.0039 8.57237C7.57538 8.57237 7.22477 8.22176 7.22477 7.79324V6.23498C7.22477 5.80646 7.57538 5.45585 8.0039 5.45585C8.43242 5.45585 8.78303 5.80646 8.78303 6.23498V7.79324C8.78303 8.22176 8.43242 8.57237 8.0039 8.57237Z" })));
};

export { ErrorIcon };
//# sourceMappingURL=ErrorIcon.esm.js.map
